import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import type { ProjectStatusProps } from '@shared/widget-schemas';
import { capitalizeFirst } from './textFormat';

export function ProjectStatusWidget({ title, summary, updatedAt }: ProjectStatusProps) {
  const timeAgo = formatTimeAgo(updatedAt);

  return (
    <Card className="w-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-base">{capitalizeFirst(title)}</CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <p className="text-sm text-muted-foreground">{capitalizeFirst(summary)}</p>
        <p className="text-xs text-muted-foreground/60 mt-2">Updated {timeAgo}</p>
      </CardContent>
    </Card>
  );
}

function formatTimeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
